module.exports = __webpack_public_path__ + "static/media/07_Treppensteigender_Rollstuhl_v2.0c3b562d.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle07/07_Treppensteigender_Rollstuhl_v2.mp4
 ** module id = 172
 ** module chunks = 0
 **/